import React from 'react';
import styles from './css/index.module.css';

const AiWardenAskPanel = ({ question, onQuestionChange, onSubmit, submitting }) => {
    return (
        <>
            <label className={styles.aiWardenSectionLabel}>Your question</label>
            <textarea
                className={styles.aiWardenAskTextarea}
                rows={5}
                value={question}
                onChange={e => onQuestionChange(e.target.value)}
                placeholder="e.g. Are there any policies we must implement before closing?"
            />
            <div className={styles.aiWardenAskActions}>
                <button type="button" className={styles.aiWardenPrimaryBtn} onClick={onSubmit} disabled={submitting}>
                    {submitting ? 'Thinking…' : 'Ask AI'}
                </button>
                <span className={styles.aiWardenTip}>Answers use only retrieved context from your selection.</span>
            </div>
        </>
    );
};

export default AiWardenAskPanel;
